import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 6.25,
		vectorEffect: "non-scaling-stroke"
	})
});
export default SvgCircleIcon;
